import { useQuery } from "react-query";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers/internalApi";
import type { Page } from "@/react/types/Page";

export const PAGES_QUERY_KEY = ["settings", "site", "pages"];

export const pageQueryKey = (pageId: number): string[] => [
  ...PAGES_QUERY_KEY,
  String(pageId),
];

export const usePage = (pageId: number) => {
  const { data, ...rest } = useQuery<Page, Error>(pageQueryKey(pageId), () =>
    reactQueryGet(
      internalApi.settings.sites.pages.show({
        pageId: pageId.toString(),
      }),
    ),
  );

  return {
    page: data,
    ...rest,
  };
};
